<template>
{{ modelValue }}
</template>
<script>
export default {
  props: {
    modelValue: {},
  }
}
</script>
